import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';

import { LazySelect } from '../ReactProtos/CellSelect';
import { Pagination } from 'react-bootstrap';

function getFriendFromCache(uuid) {
    const data = window.localStorage.getItem(`friend.${uuid}`);
    if (data) {
        const cache = JSON.parse(data);
        if (cache.expire > Date.now()) {
            return cache;
        } else {
            return null;
        }
    } else {
        return null;
    }
}

function setFriendToCache(uuid, cache) {
    cache.expire = Date.now() + 1 * 24 * 3600 * 1000;
    window.localStorage.setItem(`friend.${uuid}`, JSON.stringify(cache));
}
class UserIdImpl extends React.PureComponent {

    state = {
        friend: null,
    }

    componentDidMount() {
        const cache = getFriendFromCache(this.props.uuid);
        if (cache) {
            this.setState({ friend: cache });
        } else if (!this.props.name) {
            this.fetchFriend();
        }
    }

    async fetchFriend() {
        const response = await fetch('/api/data/search/friend', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    _id: this.props.uuid,
                },
            }),
        });
        const result = await response.json();
        const friend = result.results[0];
        setFriendToCache(this.props.uuid, friend);
        this.setState({ friend });
    }

    getName() {
        if (this.props.name) {
            return this.props.name;
        }
        if (this.state.friend) {
            return this.state.friend.name || `<TAG:${this.state.friend.tag}>`;
        }
        return `<uuid:${this.props.uuid}>`;
    }

    render() {
        return (
            <a href={`/user/${this.props.uuid}`}>{this.getName()}</a>
        );
    }
}

UserIdImpl.propTypes = {
    uuid: PropTypes.string,
    name: PropTypes.string,
};

function UserId(props) {
    return <UserIdImpl key={props.uuid} {...props} />;
}

UserId.propTypes = {
    uuid: PropTypes.string,
};

class BossLevelProgress extends React.PureComponent {
    PROGRESS_COLUMNS = [
        {
            Header: '#',
            accessor: 'levels.level_progress_index',
            Cell: row => row.value + 1,
            width: 30,
        },
        {
            Header: 'DiscoverTime',
            accessor: 'levels.discovery_time',
            Cell: row => new Date(row.value).toLocaleString(),
        },
        {
            Header: 'Participants',
            id: 'participants',
            Cell: row => <div>
                <ul>
                    {row.original.levels.participants.map(u => <li key={u.uuid}>
                        <UserId uuid={u.uuid} />: {u.damage}
                    </li>)}
                </ul>
                <p>BossHp: {row.original.levels.boss_hp}</p>
                <p>RemainingHp: {row.original.levels.boss_hp - row.original.levels.participants.reduce((s, i) => s + i.damage, 0)}</p>
            </div>
        }
    ];

    state = {
        levels: [],
    };

    componentDidMount() {
        this.fetchBossLevelProgress();
    }

    async fetchBossLevelProgress() {
        const response = await fetch('/api/data/aggregate/live_event_guild', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [
                    {
                        $match: {
                            _id: this.props.guild._id,
                        }
                    },
                    {
                        $lookup: {
                            from: 'live_event_level',
                            localField: `event_dic.${this.props.event}.boss_status.created_levels`,
                            foreignField: '_id',
                            as: 'levels',
                        }
                    },
                    { $project: { levels: 1 } },
                    { $unwind: "$levels" },
                    { $sort: { 'levels.level_progress_index': -1 } }
                ],
            }),
        });
        const result = await response.json();
        this.setState({ levels: result.results });
    }

    render() {
        return (
            <ReactTable
                data={this.state.levels}
                columns={this.PROGRESS_COLUMNS}
                pageSize={this.state.levels.length}
                showPagination={false}
            />
        );
    }
}

BossLevelProgress.propTypes = {
    guild: PropTypes.any,
    event: PropTypes.string,
};

function GuildMessage(props) {
    const message = props.message;
    return (
        <div>
            {new Date(message.timestamp).toLocaleString()} (<UserId uuid={message.sender_uuid} name={message.sender_name} />):
            {message.chat_message && message.chat_message.content}
            <span style={{ color: "orange" }}>
                {message.coop_help_message && `helped ${message.coop_help_message.level_owner_name} on ${message.coop_help_message.map_key}`}
                {message.attack_guild_boss_start_message && `starts to attack guild boss: ${message.attack_guild_boss_start_message.map_key}`}
            </span>
        </div>
    );
}

class GuildChat extends React.PureComponent {
    MEMBER_COLUMNS = [
        {
            Header: 'User',
            accessor: 'uuid',
            Cell: row => (<UserId uuid={row.original.uuid} />),
            width: 150,
        },
        {
            Header: 'Score',
            accessor: 'score',
            width: 100,
        },
        {
            Header: 'Role',
            accessor: 'guild_role',
            Cell: row => (row.original.guild_role === 1 && <b>Leader</b>),
            width: 100,
        },
    ];

    state = {
        mode: 1,
        messages: null,
        showBossLevelProgress: false,
    };

    componentDidMount() {
        this.fetchMessageList();
    }

    async fetchMessageList() {
        const pipeline = [
            { $match: { _id: this.props.guild._id } },
            { $unwind: "$messages" },
        ];
        if (this.state.mode === 1) {
            pipeline.push({ $match: { "messages.chat_message": { $ne: null } } });
        }
        pipeline.push({ $sort: { "messages.timestamp": -1 } });
        const response = await fetch('/api/data/aggregate/guild_message_history', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline,
            }),
        });
        const result = await response.json();
        this.setState({ messages: result.results.map(i => i.messages) });
    }

    handleShowBossLevelProgress = e => {
        this.setState({ showBossLevelProgress: e.target.checked });
    }

    selectMode(mode) {
        return () => {
            if (mode !== this.state.mode) {
                this.setState({ mode, messages: null }, () => this.fetchMessageList());
            }
        };
    }

    render() {
        if (!this.state.messages) {
            return "Loading...";
        }
        const scores = {};
        const xmembers = [];
        for (let score of this.props.guild.scores) {
            scores[score.k] = score.v.contribution;
            if (!this.props.guild.members.find(m => m.uuid === score.k)) {
                xmembers.push(score.k);
            }
        }
        const memberData = this.props.guild.members.map(member => ({ ...member, score: scores[member.uuid] || 0 }));
        const xmemberData = xmembers.map(uuid => ({ uuid, score: scores[uuid] || 0 }));
        return (
            <div style={{ display: 'flex' }}>
                <div style={{ width: '450px' }}>
                    <h4>Announcement</h4>
                    <p>
                        {this.props.guild.announcement}
                    </p>
                    <h4>Members</h4>
                    <ReactTable
                        data={memberData}
                        columns={this.MEMBER_COLUMNS}
                        pageSize={memberData.length}
                        showPagination={false}
                    />
                    {
                        xmemberData.length > 0 &&
                        <React.Fragment>
                            <h4>Former Members</h4>
                            <ReactTable
                                data={xmemberData}
                                columns={this.MEMBER_COLUMNS}
                                pageSize={xmemberData.length}
                                showPagination={false}
                            />
                        </React.Fragment>
                    }
                    <h4>Boss Level Progress
                        <Checkbox checked={this.state.showBossLevelProgress} onChange={this.handleShowBossLevelProgress} value="show" />
                    </h4>
                    {
                        this.state.showBossLevelProgress &&
                        <BossLevelProgress guild={this.props.guild} event={this.props.event} />
                    }
                </div>
                <div>
                    <ul>
                        <h4>Messages</h4>
                        <Pagination>
                            <Pagination.Item key={1} active={this.state.mode === 1} onClick={this.selectMode(1)}>
                                Chat Messages Only
                            </Pagination.Item>
                            <Pagination.Item key={2} active={this.state.mode === 2} onClick={this.selectMode(2)}>
                                All Messages
                            </Pagination.Item>
                        </Pagination>
                        {
                            this.state.messages.map(message => (
                                <li key={message._id}>
                                    <GuildMessage message={message} />
                                </li>
                            ))
                        }
                    </ul>

                </div>
            </div>
        );
    }
}

GuildChat.propTypes = {
    guild: PropTypes.any,
    event: PropTypes.string,
};

class GuildStats extends React.PureComponent {
    state = {
        results: null,
    };

    componentDidMount() {
        this.fetchGuildList();
    }

    async fetchGuildList() {
        const response = await fetch('/api/data/aggregate/guild', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [
                    {
                        $count: "count",
                    }
                ],
            }),
        });
        const result = await response.json();
        this.setState({ results: result.results });
    }

    render() {
        if (!this.state.results) {
            return "Loading...";
        }
        const count = this.state.results.length > 0 ? this.state.results[0].count : 0;
        return (
            <h2>Total # of guild: {count}</h2>
        );
    }
}

export class Guild extends React.PureComponent {
    GUILD_COLUMNS = [
        {
            id: "#",
            Header: "Rank",
            Cell: row => (<div>{row.index + 1}</div>),
            width: 50,
        },
        {
            Header: 'Name',
            accessor: 'name',
            width: 150,
        },
        {
            Header: 'Tag',
            accessor: 'tag',
            width: 100,
        },
        {
            Header: 'League',
            accessor: 'league.league',
            width: 100,
        },
        {
            Header: 'League Group',
            accessor: 'league.group',
            width: 100,
        },
        {
            Header: 'Total Score',
            accessor: 'total_score',
            width: 100,
        },
        {
            Header: 'Coop Score',
            accessor: 'member_score',
            width: 100,
        },
        {
            Header: 'Boss Score',
            accessor: 'guild_score',
            width: 100,
        },
        {
            Header: 'Members',
            accessor: 'member_count',
            width: 100,
        },
        {
            Header: 'Messages',
            accessor: 'message_count',
            width: 100,
        },
        {
            Header: 'Id',
            accessor: '_id',
            width: 350,
        },
        {
            Header: 'JoinType',
            accessor: 'guild_join_type',
            Cell: row => row.value === 1 ? 'require approval' : 'anyone can join',
            width: 100,
        },
        {
            Header: 'Announcement',
            accessor: 'announcement',
        },
    ];

    createGuildComponent = row => {
        return (
            <GuildChat guild={row.original} event={this.state.selectedEvent} />
        );

    }

    state = {
        events: null,
        guilds: null,
    };

    constructor(props) {
        super(props);

        this.state.selectedEvent = window.localStorage.getItem('guild.event');
    }

    componentDidMount() {
        this.fetchEventList();

        if (this.state.selectedEvent) {
            this.fetchGuildList();
        }
    }

    componentDidUpdate() {
        if (this.state.selectedEvent) {
            window.localStorage.setItem('guild.event', this.state.selectedEvent);
        }
    }

    async fetchEventList() {
        const response = await fetch('/api/data/aggregate/live_event_guild', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [
                    { $addFields: { events: { $objectToArray: "$event_dic" } } },
                    { $unwind: "$events" },
                    { $group: { _id: "$events.k" } },
                ],
                limit: 200,
            }),
        });
        const result = await response.json();
        this.setState({ events: result.results.map(i => i._id) });
    }

    async fetchGuildList() {
        const leagueResponse = await fetch('/api/data/search/live_event_guild_league', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    event_key: this.state.selectedEvent,
                },
            }),
        });
        const leagueResult = await leagueResponse.json();
        const leagueMapping = {};
        for (let leagueId in leagueResult.results[0].league_groups) {
            const league = leagueResult.results[0].league_groups[leagueId];
            for (let groupId in league.guild_groups) {
                const guilds = league.guild_groups[groupId].guilds;
                for (let guild of guilds) {
                    leagueMapping[guild] = { league: leagueId, group: groupId };
                }
            }
        }

        const response = await fetch('/api/data/aggregate/guild', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [
                    {
                        $lookup: {
                            from: 'guild_message_history',
                            let: { id: "$_id" },
                            pipeline: [
                                {
                                    $match: {
                                        $expr: { $eq: ["$_id", "$$id"] },
                                    },
                                },
                                {
                                    $addFields: {
                                        message_count: { $size: "$messages" },
                                    },
                                },
                                { $project: { message_count: 1 } },
                            ],
                            as: 'messages',
                        }
                    },
                    {
                        $unwind: '$messages',
                    },
                    {
                        $addFields: {
                            member_count: { $size: "$members" },
                            message_count: "$messages.message_count",
                        },
                    },
                    {
                        $lookup: {
                            from: 'live_event_guild',
                            let: { id: "$_id" },
                            pipeline: [
                                {
                                    $match: {
                                        $expr: { $eq: ["$_id", "$$id"] },
                                    },
                                },
                                { $project: { [`event_dic.${this.state.selectedEvent}`]: 1 } },
                            ],
                            as: 'events',
                        }
                    },
                    { $unwind: "$events" },
                    { $addFields: { scores: { $objectToArray: `$events.event_dic.${this.state.selectedEvent}.members` } } },
                    { $addFields: { member_score: { $sum: "$scores.v.contribution" } } },
                    { $addFields: { guild_score: `$events.event_dic.${this.state.selectedEvent}.total_guild_point` } },
                    { $addFields: { total_score: { $sum: ["$member_score", "$guild_score"] } } },
                    {
                        $project: {
                            name: 1,
                            tag: 1,
                            members: 1,
                            member_count: 1,
                            message_count: 1,
                            scores: 1,
                            total_score: 1,
                            announcement: 1,
                            guild_join_type: 1,
                            guild_score: 1,
                            member_score: 1,
                            league: 1,
                        }
                    },
                    {
                        $sort: { total_score: -1, member_count: -1, message_count: -1 },
                    }
                ],
                limit: 200,
            }),
        });
        const result = await response.json();
        this.setState({
            guilds: result.results.map(g => {
                const league = leagueMapping[g._id];
                if (league) {
                    return { ...g, league };
                } else {
                    return { ...g, league: { league: -1, group: -1 } };
                }
            })
        });
    }

    onChangeEvent = value => {
        this.setState({ selectedEvent: value.value }, () => this.fetchGuildList());
    }

    render() {
        window.events = this.state.events;
        window.guilds = this.state.guilds;
        if (!this.state.events) {
            return "Loading...";
        }
        return (
            <div>
                <GuildStats />
                <div>
                    Select event to view guild ranking:
                    <LazySelect value={{ value: this.state.selectedEvent, label: this.state.selectedEvent }} options={this.state.events.map(e => ({ label: e, value: e }))} onChange={this.onChangeEvent} />
                </div>
                {
                    this.state.selectedEvent && this.state.guilds &&
                    <ReactTable
                        data={this.state.guilds}
                        columns={this.GUILD_COLUMNS}
                        pageSize={this.state.guilds.length}
                        showPagination={false}
                        SubComponent={this.createGuildComponent}
                    />
                }
            </div>
        );
    }
}
